// IMPORT PACKAGE REFERENCES
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { logout } from '../state/actions/UserActions';

const pages = {
    
    'root' : {
        'path' : '',
        'sectionName': 'Dashboard',
        'previousSections': [],
        'dataSections': [],
        'pages' : [
            {
                name: 'Segments',
                path: 'segments',
                icon: 'Segments-Icon.png'
            },
            {
                name: 'Equipment',
                path: 'equipment',
                icon: 'Equipment-Icon.png'
            },
            {
                name: 'Stickers',
                path: 'stickers',
                icon: 'Sticker-Icon.png'
            },
            {
                name: 'Products',
                path: 'products',
                icon: 'Products-Icon.png'
            }
        ]
    }
};

//COMPONENT
class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeLinks : this.activeLinkSet(props.location),
            companyName: this.props.companyName,
            userEmail: this.props.userEmail
        };

        this.handleLogout = this.handleLogout.bind(this);
    }

    handleLogout() {
        this.props.logout();
    }

    numberOfUrlComponents(pathname) {
        let components = pathname.split('/');
        return components.length;
    }

    handleMenuItemClick(path) {
        this.props.history.push('/' + path);
    }

    isPageActive(pagePath) {
        return this.props.location.pathname.includes(pagePath);
    }

    activeLinkSet() {
        return pages.root;
    }

    getImage = (icon) => {
        try {
            return require(`../../images/${icon}`);
        } catch (error) {
            console.error(`Cannot find module for icon: ${icon}`, error);
            return ''; // Return a fallback or empty string if the module is not found
        }
    };

    UNSAFE_componentWillMount() {
        this.unlisten = this.props.history.listen((location) => {
            let newActiveLinks = this.activeLinkSet(location);
            if (newActiveLinks.path !== this.state.activeLinks.path) {
                this.setState({activeLinks: {pages: [], dataSections: []}}, () => {
                    setTimeout(() => { 
                        this.setState({activeLinks: newActiveLinks});
                    }, 500);
                });
            }
        });
    }

    componentDidMount(){
        this.setState({companyName: this.props.companyName});
        this.setState({userEmail: this.props.userEmail});
    }

    componentDidUpdate(prevProps){
        if(this.props.companyName != prevProps.companyName){
            this.setState({companyName: this.props.companyName});
        }

        if(this.props.userEmail != prevProps.userEmail){
            this.setState({userEmail: this.props.userEmail});
        }
    }

    componentWillUnmount() {
        this.unlisten();
    }

    render() {
        return (
            <div>
                
                <NavLink to='/'>
                    <div className="sidebar-logo-container">
                        <img className="logo" src={require('../../images/Shelfy-Icon.png')}/>
                    </div>
                </NavLink>
                
                <div className="sidebar-links">
                    
                    {this.state.activeLinks.pages.map((page, index) => (
                        <div 
                            key={page.path} 
                            style={{transitionDelay: (index * 50) + 'ms'}} 
                            onClick={(event) => this.handleMenuItemClick(page.path, event)} 
                            className={'sidebar-item ' + (this.isPageActive(page.path) ? 'active' : '')}
                        >   
                            <img className='sidebar-item-logo' height={30} width={30} src={this.getImage(page.icon)} /> 
                            
                            { page.name }
                        </div>
                    ))}
                </div>
                <div className="company-name">{this.state.companyName}</div>
                <div className="user-email">{this.state.userEmail}</div>
                <div className="logout" onClick={() => this.handleLogout()}>Logout</div>
                
            </div>
        );
    }
}

Sidebar.propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    loggedIn: PropTypes.bool.isRequired,
    logout: PropTypes.func.isRequired,
    companyName: PropTypes.string.isRequired,
    userEmail: PropTypes.string.isRequired
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { loggedIn, companyName, userEmail } = state.userReducer;
    return { loggedIn, companyName, userEmail };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({ logout }, dispatch)
);

const hoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(Sidebar));

// EXPORT COMPONENT

export { hoc as Sidebar };




// WEBPACK FOOTER //
// ./src/components/Navigation/Sidebar.js